// import AssignJobsService from "../service/AssignService";

// export const fetchJobs = (date, serviceNumber) => async dispatch => {
//   dispatch({ type: "FETCH_ASSIGN_JOB_REQUEST" });
//   try {
//     const response = await AssignJobsService.getJobs(date, serviceNumber);

//     dispatch({type: "FETCH_ASSIGN_JOB_SUCCESS", payload: response.data.JobsList});
   
//   } catch (error) {
//     console.error("Error fetching job data", error);
//     dispatch({ type: "FETCH_ASSIGN_JOB_FAILURE" });
//   }
// };

// export const fetchLocations = (company) => async dispatch => {
//   dispatch({ type: "FETCH_JOB_LOCATION_REQUEST" });
//   try {
//     const response = await AssignJobsService.getLocationby(company);
    
//     dispatch({type: "FETCH_JOB_LOCATION_SUCCESS", payload: response.data.LocationList});
//   } catch (error) { 
//     console.error("Error fetching location data", error);
//     dispatch({ type: "FETCH_JOB_LOCATION_FAILURE" });
//   }
// };


// export const assignJob = (postData) => async (dispatch) => {
//   dispatch({ type: "ASSIGN_JOB_REQUEST" });
//   try {
//     const response = await AssignJobsService.post("PostJobArray", postData);
//     dispatch({ type: "ASSIGN_JOB_SUCCESS", payload: response.data });
//   } catch (error) {
//     dispatch({ type: "ASSIGN_JOB_FAILURE", error: error.message });
//   }
// };



import AssignJobsService from "../service/AssignService";

export const fetchJobs = (date, serviceNumber) => async dispatch => {
  dispatch({ type: "FETCH_ASSIGN_JOB_REQUEST" });
  try {
    const response = await AssignJobsService.get(
      `GetJobs?date=${date}&serviceNo=${serviceNumber}`
    );
    dispatch({type: "FETCH_ASSIGN_JOB_SUCCESS", payload: response.data.JobsList});
    //console.log(response.data.JobsList);
  } catch (error) {
    console.error("Error fetching job data", error);
    dispatch({ type: "FETCH_ASSIGN_JOB_FAILURE" });
  }
};

export const fetchLocations = (company) => async dispatch => {
  dispatch({ type: "FETCH_JOB_LOCATION_REQUEST" });
  try {
    const response = await AssignJobsService.get(
      `GetLocationsByCompany?company=${company}`
    );
    dispatch({type: "FETCH_JOB_LOCATION_SUCCESS", payload: response.data.LocationList});
  } catch (error) { 
    console.error("Error fetching location data", error);
    dispatch({ type: "FETCH_JOB_LOCATION_FAILURE" });
  }
};


export const assignJob = (postData) => async (dispatch) => {
  dispatch({ type: "ASSIGN_JOB_REQUEST" });
  try {
    const response = await AssignJobsService.post("PostJobArray", postData);
    dispatch({ type: "ASSIGN_JOB_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "ASSIGN_JOB_FAILURE", error: error.message });
  }
};



// export const fetchLocation = (company) => async (dispatch) => {
//   dispatch({ type: "FETCH_ASSIGN_JOB_REQUEST" });
//   try {
//     const response = await AssignJobsService.get(
//       `GetLocationsByCompany?company=${company}`
//     );
//     console.log("API Response Data:", response.data);
//     dispatch({
//       type: "FETCH_ASSIGN_JOB_SUCCESS",
//       payload: response.data.LocationList,
//     });
//   } catch (error) {
//     console.error("Error fetching Location List", error);
//     dispatch({ type: "FETCH_ASSIGN_JOB_FAILURE" });
//   }
// };


// export const fetchAttendance = (date, company, location1) => async dispatch => {
//   dispatch({ type: "FETCH_ATTENDANCE_REQUEST" });
//   try {
    
//     const response = await AssignJobsService.get(
//       `GetAttendance?date=${date}&company=${company}&location=${location1}`
//     );
//     dispatch({ type: "FETCH_ATTENDANCE_SUCCESS", payload: response.data.AttendancList });
//   } catch (error) {
//     console.error("Error fetching attendance data:", error);
//     dispatch({ type: "FETCH_ATTENDANCE_FAILURE" });
//   }
// };